import { render, staticRenderFns } from "./ProjectFiltersContainer.vue?vue&type=template&id=5f1f084c&scoped=true&lang=pug&"
import script from "./ProjectFiltersContainer.vue?vue&type=script&lang=js&"
export * from "./ProjectFiltersContainer.vue?vue&type=script&lang=js&"
import style0 from "./ProjectFiltersContainer.vue?vue&type=style&index=0&id=5f1f084c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1f084c",
  null
  
)

export default component.exports